import { initializeApp, getApps } from 'firebase/app';
import { getAuth } from 'firebase/auth';

// Firebase Configuration
const firebaseConfig = {
  apiKey: "AIzaSyBjMz2AhQuE3tnYly0zCozxjrH72a6nz34",
  authDomain: "esayt-4f764.firebaseapp.com",
  projectId: "esayt-4f764",
  storageBucket: "esayt-4f764.firebasestorage.app",
  messagingSenderId: "483350583500",
  appId: "1:483350583500:web:8a37ecb25ee2601f808a69",
  measurementId: "G-Q322PJKP5B"
};

export function getFirebase() {
  if (getApps().length === 0) {
    return initializeApp(firebaseConfig);
  }
  return getApps()[0];
}

export function getFirebaseAuth() {
  const app = getFirebase();
  return getAuth(app);
}

// Export auth instance for direct use
export const auth = getFirebaseAuth();